import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b067d8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = { class: "flex-item mt-3" }
const _hoisted_3 = {
  class: "flex-item ml-5",
  style: {"align-self":"flex-end"}
}
const _hoisted_4 = {
  key: 1,
  align: "center"
}
const _hoisted_5 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_6 = { align: "start" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = {
  key: 4,
  align: "start"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 7,
  align: "end"
}
const _hoisted_11 = {
  key: 8,
  align: "end"
}

import { useI18n } from 'vue-i18n'
import {
  ref,
  onMounted,
  computed,
  Ref,
  onBeforeUnmount,
} from 'vue'
import { Delta } from '@vueup/vue-quill'
import { broadcastingActions } from '@/stores/broadcasting-store'
import { RequestResponse } from '@/types'
import { useToast } from 'vue-toast-notification'
import { Message } from '@/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'MessageBox',
  props: {
    content: {},
    title: {},
    editView: { type: Boolean },
    broadcast: { type: Boolean },
    id: {},
    studentView: { type: Boolean },
    doctorName: {},
    doctorProfile: {}
  },
  emits: ['closed', 'closeDialog'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { t } = useI18n()
const emit = __emit
const broadcast = ref(props.broadcast)
const editorContent = ref<Delta | undefined>(props.content)
const broadcasting = broadcastingActions()
const loading = ref(false)
const title = ref<string>(props.title)
const $toast = useToast()
const requestResponse = ref<RequestResponse>()
const id = ref(props.id)
const editView = ref(props.editView)
const doctorName = ref(props.doctorName)
const doctorProfile = ref(props.doctorProfile)
const smallWindow = ref(window.innerWidth < 1000)

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

onMounted(() => {
  window.addEventListener('resize', updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowSize)
})

const updateContent = async () => {
  loading.value = true
  const contents = {
    title: title.value,
    content: editorContent.value,
  }

  const response = await broadcasting.updateMessage(contents, id.value ?? '')
  requestResponse.value = response
  if (response.success) {
    $toast.success(t('successfully-updated'), {
      position: 'top-right',
    })
  } else {
    $toast.error(t('successfully-not-updated'), {
      position: 'top-right',
    })
  }

  emit('closed', requestResponse.value)
}

const sendContent = async () => {
  loading.value = true
  const contents = {
    title: title.value,
    content: editorContent.value,
  }

  const response = await broadcasting.broadcastMessage(contents)
  requestResponse.value = response
  if (response.success) {
    $toast.success(t('successfully-broadcasted'), {
      position: 'top-right',
    })
  } else {
    $toast.error(t('successfully-not-broadcasted'), {
      position: 'top-right',
    })
  }
  emit('closed', requestResponse.value)

  broadcast.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: broadcast.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((broadcast).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        border: "md",
        class: "pa-6 text-black mx-auto",
        color: "white",
        style: {"border-radius":"7%"},
        "min-width": smallWindow.value ? '350px' : '400px',
        "max-width": smallWindow.value ? '360px' : '600px'
      }, {
        default: _withCtx(() => [
          (_ctx.studentView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('message-from')), 1),
                  _createElementVNode("p", null, _toDisplayString(doctorName.value), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_img, {
                    src: doctorProfile.value,
                    width: "100px",
                    style: {"border-radius":"50%"}
                  }, null, 8, ["src"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.studentView)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(editView.value ? _ctx.$t('edit-message') : _ctx.$t('new-message')), 1))
            : _createCommentVNode("", true),
          (_ctx.studentView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('title')), 1),
                _createElementVNode("p", _hoisted_7, _toDisplayString(title.value), 1)
              ]))
            : (_openBlock(), _createBlock(_component_v_text_field, {
                key: 3,
                class: "mt-2",
                modelValue: title.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
                "prepend-inner-icon": "mdi-email-fast-outline",
                label: _ctx.$t('title'),
                variant: "outlined",
                "persistent-hint": ""
              }, null, 8, ["modelValue", "label"])),
          (_ctx.studentView)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.$t('message')), 1))
            : _createCommentVNode("", true),
          (_ctx.studentView)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                innerHTML: editorContent.value
              }, null, 8, _hoisted_9))
            : (_openBlock(), _createBlock(_component_QuillEditor, {
                key: 6,
                content: editorContent.value,
                "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((editorContent).value = $event)),
                contentType: "html",
                style: {"min-height":"200px"},
                theme: !_ctx.studentView ? 'snow' : '',
                toolbar: "essential",
                "read-only": _ctx.studentView
              }, null, 8, ["content", "theme", "read-only"])),
          (!_ctx.studentView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_btn, {
                  class: "mt-4",
                  color: "error",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeDialog')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('go-back')), 1)
                  ]),
                  _: 1
                }),
                (!editView.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "ml-3 mt-4",
                      color: "green",
                      onClick: sendContent
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('send')), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "ml-3 mt-4",
                      color: "green",
                      onClick: updateContent
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('done')), 1)
                      ]),
                      _: 1
                    }))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_v_btn, {
                  class: "mt-4",
                  color: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeDialog')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                  ]),
                  _: 1
                })
              ]))
        ]),
        _: 1
      }, 8, ["min-width", "max-width"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})